var React = require('react');

function SocialFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.64844 12.052C2.64844 16.7026 6.02605 20.5697 10.4435 21.3539V14.5979H8.105V11.9998H10.4435V9.92085C10.4435 7.58232 11.9503 6.28366 14.0815 6.28366C14.7565 6.28366 15.4846 6.38733 16.1597 6.49101V8.88176H14.9647C13.8211 8.88176 13.5616 9.45314 13.5616 10.1812V11.9998H16.056L15.6405 14.5979H13.5616V21.3539C17.979 20.5697 21.3566 16.7034 21.3566 12.052C21.3566 6.87842 17.1473 2.64569 12.0025 2.64569C6.85778 2.64569 2.64844 6.87842 2.64844 12.052Z","fill":"currentColor"}));
}

SocialFacebook.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = SocialFacebook;

SocialFacebook.default = SocialFacebook;
